<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option v-if="firstOption !== null" value="">{{ firstOption }}</option>
    <option
      v-for="status in selects"
      :key="status.id"
      :value="status.id"
      :selected="status.id === selected"
      >{{ status.name }}</option
    >
  </select>
</template>

<script>
export default {
  name: 'SelectUsersStatus',
  data() {
    return {
      selects: [],
      firstOption: this.first ? this.first : 'Todos',
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
  },
  methods: {
    getData() {
      this.selects = [
        { id: 1, name: 'Ativo' },
        { id: 0, name: 'Inativo' },
      ];
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
